<template>
  <div id="app">
    <Header ref="header" />
    <div class="container-md container-fluid mt-7 py-4">
      <CountDown v-if="isShowTimer" ref="timer" @setCount="setCount" class="mb-3" />
      <router-view
        :key="$route.fullPath"
        @stopTimer="stopTimer"
        @startTimer="startTimer"
        @closePop="closePop"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import HttpClient from "@/services/httpClient";
import CountDown from "@/components/CountDown.vue";
import Header from "@/components/Header.vue";
@Component({
  components: {
    CountDown,
    Header
  }
})
export default class App extends Vue {
  $refs: any = {
    timer: CountDown,
    header: Header
  };
  private pasTime: number = 0;
  private isShowTimer: boolean = false;
  private dao: HttpClient = new HttpClient();

  created() {
    this.isShowTimer = false;
  }

  mounted() {
    const agent = window.navigator.userAgent.toLowerCase();
    console.log(agent);
    if (agent.indexOf("msie") != -1 || agent.indexOf("trident") != -1) {
    } else if (agent.indexOf("edg") != -1 || agent.indexOf("edge") != -1) {
    } else if (agent.indexOf("opr") != -1 || agent.indexOf("opera") != -1) {
    } else if (agent.indexOf("chrome") != -1) {
    } else if (agent.indexOf("safari") != -1) {
      window.onpopstate = function(event: any) {
        window.location.href = "/?error=back";
      };
    } else if (agent.indexOf("firefox") != -1) {
    } else if (agent.indexOf("opr") != -1 || agent.indexOf("opera") != -1) {
    }
  }

  private setCount(value: number): void {
    let min = Math.floor(value / 60);
  }

  public startTimer() {
    this.isShowTimer = true;
    const vm = this;
    this.$nextTick(() => {
      this.$refs.timer.start(15);
    });
  }

  public stopTimer() {
    if (!this.isShowTimer || !this.$refs.timer) return;
    this.$refs.timer.stop();
    this.isShowTimer = false;
  }

  public closePop() {
    this.$refs.header.closePop();
  }
}
</script>
<style>
.justify {
  display: flex;
  justify-content: space-between;
}
.mt-7 {
  margin-top: 60px;
}
.container-fluid {
  margin-right: auto;
  margin-left: auto;
  max-width: 834px;
}
body {
  background-color: rgb(241 245 249);
}

.border-red {
  border: solid 1px #dc3545 !important;
}

.list-flex {
  display: flex;
  align-items: center;
}

.text-green-600 {
  color: #244f1b;
}

.text-green-300 {
  color: #387d2a;
}
.bg-slate-500 {
  background-color: rgb(100 116 139) !important;
}

.bg-slate-600 {
  background-color: rgb(51 65 85) !important;
}
</style>